import { Button, Table, Tag } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import colorsDark from '../../../../assets/colors/dark';

const NamespaceActivationTable = ({
  rowSelection,
  dataNamespace,
  handleTableChange,
  isLoadActiveLicenseNamespace,
  license,
  onDeactivateNameSpace,
  singleActiveNamespace,
}) => {
  console.log("🚀 ~ NamespaceActivationTable ~ dataNamespace:", dataNamespace)
  const { t } = useTranslation();

  return (
    <Table
      rowClassName={(record) => !record.enabled && 'disabled-row'}
      rowSelection={rowSelection}
      dataSource={dataNamespace?.data ?? []}
      loading={dataNamespace && dataNamespace.loading}
      onChange={handleTableChange}
      columns={[
        {
          title: t('Namespace'),
          dataIndex: 'namespace',
          key: 'namespace_namespace',
        },
        {
          title: t('State'),
          key: 'log_action',
          width: 130,
          render: (item) =>
            isLoadActiveLicenseNamespace.some((id) => id === item.id) ? (
              <Tag
                style={{ width: 120, textAlign: 'center' }}
                color={colorsDark.$warning}
              >
                {t('Activating')}
              </Tag>
            ) : item.active ? (
              <Tag
                style={{ width: 120, textAlign: 'center' }}
                color={colorsDark.$online}
              >
                {t('Activated')}
              </Tag>
            ) : (
              <Tag
                style={{ width: 120, textAlign: 'center' }}
                color={colorsDark.$offline}
              >
                {t('Not activated')}
              </Tag>
            ),
        },
        {
          title: t('Action'),
          key: 'actions',
          width: 130,
          render: (item) =>
            item.active ? (
              <div
                className="edit-button"
                onClick={() => onDeactivateNameSpace()}
              >
                <Button danger htmlType="submit">
                  {t('Deactivate')}
                </Button>
              </div>
            ) : (
              <div
                className="edit-button"
                onClick={() => singleActiveNamespace()}
              >
                <Button
                  loading={isLoadActiveLicenseNamespace.some(
                    (id) => id === item.id
                  )}
                  disabled={!license}
                  htmlType="submit"
                >
                  {t('Activate')}
                </Button>
              </div>
            ),
        },
      ]}
    />
  );
};

export default NamespaceActivationTable;
